import styled from "@emotion/styled";

export const BreadCrumbsStyled = styled.div`
  a {
    text-decoration: none;
  }
`;
